import React, { useMemo } from 'react';
import type { ReactNode } from 'react';
import { useFragment } from 'react-relay';

import { SpaceDetailFragment } from './SpaceDetail.fragment.ts';
import { SpaceDetailContext } from './SpaceDetailContext.ts';
import type { SpaceDetail_space$key } from './__generated__/SpaceDetail_space.graphql.ts';

/** Reuse only the space selected by this owner; other spaces retain their own query. */
export const SpaceDetailProvider = ({
	children,
	spaceKey,
	loading,
	spaceFragmentRef,
}: {
	children: ReactNode;
	spaceKey: string;
	loading: boolean;
	spaceFragmentRef: SpaceDetail_space$key | null;
}): React.JSX.Element => {
	const space = useFragment(SpaceDetailFragment, spaceFragmentRef);
	const value = useMemo(
		() =>
			loading || (space?.id && (space.key === spaceKey || space.alias === spaceKey))
				? { spaceKey, loading, space: space ?? undefined }
				: undefined,
		[loading, space, spaceKey],
	);
	return <SpaceDetailContext.Provider value={value}>{children}</SpaceDetailContext.Provider>;
};
